<template>
    <section>
    <mdb-navbar  class="newbg z-depth-0 pt-0 pb-0" style="height: 85px;z-index: 102">
        <mdb-navbar-toggler class="container h-100">
            <mdb-navbar-brand class="w96">
                <a class="btn-logo"  href="/">
                    <img src="../assets/images/nLogo.png">
                </a>
            </mdb-navbar-brand>
            <div class="d-none  d-lg-block">
                <mdb-navbar-nav right class="h-100 h-center ">
                <span v-for="(link, index) in links" :key="index">
                <mdb-nav-item  v-if="link.navi">
                    <router-link :to="link.to"><img :src="link.icon" /> {{ link.name }}</router-link>
                </mdb-nav-item>
                <mdb-dropdown  v-else  tag="li" megaMenu class="nav-item" style="display: block">
                    <mdb-dropdown-toggle tag="a" navLink color="" slot="toggle" waves-fixed>
                        <img :src="link.icon" /> {{ link.name }}</mdb-dropdown-toggle>
                    <mdb-dropdown-menu class="mega-menu v-2 z-depth-1 biletbul-bg-blue py-5 px-3 bl-mega-menu">
                        <div class="form-group" v-for="node in link.nodes">
                            <div v-if="node.input==true">
                                <label :for="node.input_name">{{node.name}}</label>
                                <input
                                      type="text"
                                      class="form-control"
                                      :name="node.input_name"
                                      :id="node.input_name"
                                      placeholder=""
                                      @click.stop
                                      v-model="reservationForm[node.input_name]"
                                />
                            </div>
                            <a type="button" v-if="node.button==true" class="btn-block btn btn-biletbul-bg-red" @click="reservationSearch">{{node.name}}</a>
                            <a :href="node.url" v-if="node.link==true" class="">{{node.name}}</a>
                        </div>
                    </mdb-dropdown-menu>
                </mdb-dropdown>
                </span>
                </mdb-navbar-nav>
            </div>

            <mdb-icon icon="bars" @click.native="modal = true" size="2x"/>
        </mdb-navbar-toggler>
    </mdb-navbar>

        <!-- Side Modal Top Right -->
        <mdb-modal fullHeight position="top-right" direction="right" :show="modal" @close="modal = false" class="sidenav-menu">
            <mdb-modal-header>
                <mdb-modal-title><img src="../assets/images/Logo.png"></mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>
                <ul class="list-unstyled">
                    <li v-for="(navlink,index) in sidenavlinks" :key="index" v-if="navlink.to">
                        <a :href="navlink.to" @click="modal = false">{{navlink.name}}</a>
                    </li>
                </ul>
                <ul class="list-unstyled">
                    <li v-for="(navlink,index) in sidenavlinks2" :key="index" v-if="navlink.to">
                        <a :href="navlink.to" @click="modal = false" >{{navlink.name}}</a>
                    </li>
                </ul>
                <ul class="list-unstyled">
                    <li v-for="(navlink,index) in sidenavlinks3" :key="index" v-if="navlink.to">
                        <a :href="navlink.to" @click="modal = false">{{navlink.name}}</a>
                    </li>
                </ul>
            </mdb-modal-body>

        </mdb-modal>
    </section>
</template>

<script>
    import { mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbInput, mdbDropdownItem, mdbIcon,mdbBtn,mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
    export default {
        name: 'header.vue',
        components: {
            mdbNavbar,
            mdbNavbarBrand,
            mdbNavbarToggler,
            mdbNavbarNav,
            mdbNavItem,
            mdbDropdown,
            mdbDropdownMenu,
            mdbDropdownToggle,
            mdbDropdownItem,
            mdbInput,
            mdbIcon,
            mdbBtn,
            mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter
        },
        data: () => ({
            reservationForm:[],
            links : [
                {
                    name: 'KAMPANYALAR',
                    to: '/kampanyalar',
                    icon: require('../assets/images/Kampanyalar.png'),
                    navi:1
                },
                {
                    name: 'BİLET İŞLEMLERİ',
                    to: '#',
                    icon: require('../assets/images/Bilet.png'),
                    nodes:[
                        {name:"Rezervasyon No",input:true,input_name:"reservation_number",button:false,link:false,url:""},
                        {name:"Soyadınız",input:true,input_name:"reservation_surname",button:false,link:false,url:""},
                        {name:"Ara",input:false,input_name:"",button:true,link:false,url:""},
                        {name:"İptal - İade İşlemleri",input:false,input_name:"",button:false,link:true,url:"#"},
                        {name:"Rezervasyonlarım",input:false,input_name:"",button:false,link:true,url:"#"},
                        ]
                },
                /*{
                    name: 'CHARTER İŞLEMLERİ',
                    to: '#',
                    icon: require('../assets/images/Charter.png'),
                    navi:1
                }*/
            ],
            sidenavlinks : [
                {
                    name: 'Giriş yap veya Üye ol',
                    to: '/#/register-login',
                },
                {
                    name: 'Üye Giriş',
                    to: '',
                },
                {
                    name: 'Şifremi Unuttum',
                    to: '',
                },
                {
                    name: 'Online Check-In',
                    to: '',
                },
                {
                    name: 'İptal - İade İşlemleri',
                    to: '',
                },
            ],
            sidenavlinks2 : [
                {
                    name: 'Online Check-In',
                    to: '',
                },
                {
                    name: 'İptal - İade İşlemleri',
                    to: '',
                },
                {
                    name: 'Rezervasyonlarım',
                    to: '',
                },
                {
                    name: 'Charter Uçuşları',
                    to: '',
                },
                {
                    name: 'Bilet Kampanyaları',
                    to: '',
                },
            ],
            sidenavlinks3 : [
                {
                    name: 'Hakkımızda',
                    to: '/#/p/hakkimizda',
                },
                {
                    name: 'Sıkça Sorulan Sorular',
                    to: '/#/sss',
                },
                {
                    name: 'İletişim',
                    to: '/#/iletisim',
                },
                {
                    name: 'Kişisel Verilerin Korunması, Gizlilik Politikası ve Çerez (Cookie) Kullanımı İlkeleri',
                    to: '/#/gizlilik-sozlesmesi',
                },
            ],
            modal: false

        }),
        methods:{
            reservationSearch(){
                window.location.href = "/#/reservation_check?booking_code="+this.reservationForm['reservation_number']+"&surname="+this.reservationForm['reservation_surname'];
                console.log(this.reservationForm)
            }
        }

    }
</script>

<style scoped>

</style>
